import { connectInfiniteHits } from 'react-instantsearch-dom';
import styles from './hits.module.scss';
import SearchHit from './searchHit/searchHit';

const Hits = ({ locale, hits, hasMore, refineNext, searchQuery, globals }) => {
  const { viewAll } = globals[0];
  const { localesWithWebshop } = globals[1];
  const { outOfStock } = globals[2];
  const { localesWithUnitPrice, unitPriceStackText } = globals[4];

  const hitGlobalResource = {
    localesWithWebshop,
    outOfStock,
    secondpartsettings: {
      localesWithUnitPrice,
      unitPriceStackText,
    },
  };
  const productHits = hits.map(product => {
    const {
      objectID,
      title,
      slug,
      shopifyData,
      productTags,
      thumbnailImage,
      __typename,
      productsCollection,
      size,
    } = product;

    return {
      objectID,
      title,
      slug,
      size,
      shopifyData,
      productsCollection,
      productTags,
      image: thumbnailImage,
      type: __typename,
    };
  });

  return (
    <>
      <div className={styles.resultsWrapper}>
        {productHits.map(hit => (
          <SearchHit
            locale={locale}
            key={hit.objectID}
            className={styles.searchHit}
            searchHitData={hit}
            searchQuery={searchQuery}
            // JW's request in productive 10232808
            // showPrice={localesWithWebshop?.onOrOff}
            resources={hitGlobalResource}
          />
        ))}
      </div>
      {hasMore && (
        <button type="button" className={styles.nextButton} onClick={() => refineNext()}>
          {viewAll.text}
        </button>
      )}
    </>
  );
};

const CustomHits = connectInfiniteHits(Hits);

export default CustomHits;
